import React, { Component } from "react";
import { connect } from "react-redux";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import _ from "lodash";

import LocaleStrings from "Languages";

class SessionRatingItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { printList, total, ratings } = this.props;
    var star1 = 0,
      star2 = 0,
      star3 = 0,
      star4 = 0,
      star5 = 0,
      star1Count = 0,
      star2Count = 0,
      star3Count = 0,
      star4Count = 0,
      star5Count = 0;

    if (ratings.length > 0) {
      var star1Total = _.filter(ratings, function (sel) {
        return sel.value == 1;
      });
      var star2Total = _.filter(ratings, function (sel) {
        return sel.value == 2;
      });
      var star3Total = _.filter(ratings, function (sel) {
        return sel.value == 3;
      });
      var star4Total = _.filter(ratings, function (sel) {
        return sel.value == 4;
      });
      var star5Total = _.filter(ratings, function (sel) {
        return sel.value == 5;
      });

      star1 = (star1Total.length * 100) / total;
      star2 = (star2Total.length * 100) / total;
      star3 = (star3Total.length * 100) / total;
      star4 = (star4Total.length * 100) / total;
      star5 = (star5Total.length * 100) / total;
      star1Count = star1Total.length;
      star2Count = star2Total.length;
      star3Count = star3Total.length;
      star4Count = star4Total.length;
      star5Count = star5Total.length;
    }
    var style = { width: "85%!important" };

    return (
      <div className="col-md-4" style={{ marginTop: 30 }}>
        <h4>
          <u>{printList.label}</u>
        </h4>
        <div className="poll-option-display">
          <span>{LocaleStrings.polls_qa_rating_text_5_star}</span>
          <div className="d-flex" style={{ marginTop: "6px" }}>
            <OverlayTrigger
              key="refresh"
              placement="top"
              overlay={
                <Tooltip id="tooltip-manage">
                  <span className="tag-label-effect-time">
                    {LocaleStrings.total} {star5Count}
                  </span>
                </Tooltip>
              }
            >
              <ProgressBar now={star5} className="progress-main-rating" />
            </OverlayTrigger>
            <div style={{ paddingTop: 5, marginLeft: 17 }}>
              {star5.toFixed(2)}%
            </div>
          </div>
        </div>
        <div className="poll-option-display">
          <span>{LocaleStrings.polls_qa_rating_text_4_star}</span>
          <div className="d-flex" style={{ marginTop: "6px" }}>
            <OverlayTrigger
              key="refresh"
              placement="top"
              overlay={
                <Tooltip id="tooltip-manage">
                  <span className="tag-label-effect-time">
                    {LocaleStrings.total} {star4Count}
                  </span>
                </Tooltip>
              }
            >
              <ProgressBar now={star4} className="progress-main-rating" />
            </OverlayTrigger>
            <div style={{ paddingTop: 5, marginLeft: 17 }}>
              {star4.toFixed(2)}%
            </div>
          </div>
        </div>
        <div className="poll-option-display">
          <span>{LocaleStrings.polls_qa_rating_text_3_star}</span>
          <div className="d-flex" style={{ marginTop: "6px" }}>
            <OverlayTrigger
              key="refresh"
              placement="top"
              overlay={
                <Tooltip id="tooltip-manage">
                  <span className="tag-label-effect-time">
                    {LocaleStrings.total} {star3Count}
                  </span>
                </Tooltip>
              }
            >
              <ProgressBar now={star3} className="progress-main-rating" />
            </OverlayTrigger>
            <div style={{ paddingTop: 5, marginLeft: 17 }}>
              {star3.toFixed(2)}%
            </div>
          </div>
        </div>
        <div className="poll-option-display">
          <span>{LocaleStrings.polls_qa_rating_text_2_star}</span>
          <div className="d-flex" style={{ marginTop: "6px" }}>
            <OverlayTrigger
              key="refresh"
              placement="top"
              overlay={
                <Tooltip id="tooltip-manage">
                  <span className="tag-label-effect-time">
                    {LocaleStrings.total} {star2Count}
                  </span>
                </Tooltip>
              }
            >
              <ProgressBar now={star2} className="progress-main-rating" />
            </OverlayTrigger>
            <div style={{ paddingTop: 5, marginLeft: 17 }}>
              {star2.toFixed(2)}%
            </div>
          </div>
        </div>
        <div className="poll-option-display">
          <span>{LocaleStrings.polls_qa_rating_text_1_star}</span>
          <div className="d-flex" style={{ marginTop: "6px" }}>
            <OverlayTrigger
              key="refresh"
              placement="top"
              overlay={
                <Tooltip id="tooltip-manage">
                  <span className="tag-label-effect-time">
                    {LocaleStrings.total} {star1Count}
                  </span>
                </Tooltip>
              }
            >
              <ProgressBar now={star1} className="progress-main-rating" />
            </OverlayTrigger>
            <div style={{ paddingTop: 5, marginLeft: 17 }}>
              {star1.toFixed(2)}%
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};
export default connect(mapStateToProps)(SessionRatingItem);
